module.exports = __webpack_public_path__ + "static/media/accessoires-casque.67605a1a.jpg";